<template>
	<div class="find-help-details contain">
		<main>
			<h1 class="fs-32 mb-32 lh-38 fw-800 show-xl">Hire Help for a Job</h1>
			<div class="card-v2">
				<SearchForm
				noFilters
				v-model="event"
				v-bind="forward"
				@save="search"
				:confirm-discard="!isSearching"
				/>
			</div>
		</main>
		<aside>
			<div class="card-v2">
				<h2 class="heading-3 m0" :id="sidebarHeadingId">{{ eventName || 'Job Details' }}</h2>
				<EventDetailsNew v-if="showEventDetails" :event="event" class="mt-12"/>
				<p v-else>Please fill out job information.</p>
			</div>
		</aside>
	</div>
</template>

<script>
import SearchForm from '@/components/forms/SearchForm';
import EventDetailsNew from '@/components/jobs/EventDetailsNew';
import { toString } from '@/helpers/convert';
import form from '@/mixins/form';
import JobEvent from '@/models/JobEvent';
import JobEventLocation from '@/models/JobEventLocation';

export default {
  name: 'FindHelpDetails',
  mixins: [form],
  components: { EventDetailsNew, SearchForm },
  data() {
    return {
      /** @type {JobEvent} */
      event: new JobEvent({ locations: [new JobEventLocation()] }),
      /** @type {boolean} */
      isSearching: false,
    };
  },
  computed: {
    /**
     * @returns {string | null}
     */
    eventName() {
      return toString(this.event?.name).trim() || null;
    },
    /**
     * @returns {string | null}
     */
    eventTypeName() {
      return this.event?.type?.name || null;
    },
    /**
     * @returns {boolean}
     */
    showEventDetails() {
      const { event } = this;
      return !!(
        event &&
        this.eventName &&
        (event.startedAt != null ||
          event.locations.some((loc) => loc.latitude != null && loc.longitude != null) ||
          event.minimumPaidHours != null ||
          toString(event.notes).trim())
      );
    },
    /**
     * @returns {string}
     */
    sidebarHeadingId() {
      return 'search-sidebar-heading';
    },
  },
  methods: {
    async search() {
      if (this.isLoading || this.isSearching) {
        return;
      }
      this.isSearching = true;
      try {
        /** @type {globalThis.JobEvent} */
        const event = await this.action('events/createEvent', this.event);
        const store = this.$store;
        store.commit('events/setSearchEvent', event);
        store.commit('events/setSearchQueue', null);
        this.$router.push({
          name: this.$routes.FindHelpSearch.name,
          params: { eventId: event.id },
        });
      } catch (e) {
        console.error(e);
        this.isSearching = false;
      }
    },
  },
  metaInfo: {
    title: 'Find Help',
  },
};
</script>
